import { Box, Card, CardContent, Typography } from '@mui/material'

export default function BlogsPage() {
    return (
        <Box>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 3 }}>Blog Posts</Typography>
            <Card>
                <CardContent sx={{ p: 4, textAlign: 'center' }}>
                    <Typography variant="body1" sx={{ color: 'grey.500' }}>
                        Manage blog posts here. Create, edit, and publish solar energy educational content.
                    </Typography>
                </CardContent>
            </Card>
        </Box>
    )
}
